<template>
<div>
    <!-- <headerComponent/> -->
    <div class="pageContainer">
        <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
            <slide v-for="image in images" :key="image">  
                <img :src="require(`${image}`)" alt="carousel image">  
            </slide>  
        </carousel>   -->
         <img :src="curImg.src" alt="" srcset="" style="width:100%;"  class="animate__animated animate__slideInLeft">

    </div>
    <div class="containerOne" style="position:relative;width:100%;min-height:820px;margin:45px 0 0 0">
      <div style="width:1300px;margin:0 auto">
        
        <!-- 公共组建开始 -->
        <module-tit :title="equipmentObj?.cateInfo?.sub_name" :subTitle="equipmentObj?.cateInfo?.name" titleStyle="width:505px" subTitleStyle="width:795px"/>
        <!-- 公共组件结束 -->
        <div class="one" style="position:relative;height:500px;width:100%;background:#272a36;" v-for="(item,index) in equipmentObj?.data" :key="index" @click="handleDetail(item)">
          <div class="clearfix" :style="index%2==0?'display: inline-block;width:70%;':'width:70%;float:left;'"  v-animate-onscroll="'animate__animated animate__fadeInRight'"> 
          <img :src="item.thumb" alt="" srcset="" style="width:100%;height:500px;display:block;float:right"  >
            </div>
          <div class="module" style="float:left;width:30%;padding:60px 0 0 0;"  v-animate-onscroll="'animate__animated animate__fadeInLeft'">
            <div style="width:310px;height:380px;margin:0 auto;">
              <img src="@/views/equipment/images/icon01.png" alt="" srcset="" style="width:20px">
              <div style="width:100%;height:50px;text-align:left;border-bottom:1px solid #ccc;padding:10px 0 0 0">
                <span style="font-size:24px;font-weight:300;color:#fff">{{item.title}}</span>
              </div>
              <div>
                <span style="font-size:14px;display:block;padding:100px 0 0 0;color:#ccc;line-height:28px;letter-spacing:1px;">
                  {{item.des}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="clearBoth"></div>
        
      </div>
    </div>
</div>
</template>
<script>
import moduleTit from '@/components/moduleTit'
import { getList ,cate } from '@/api/index.js'
export default {
  name: 'App',
   components:{
    moduleTit
   },
  data() {  
    return {  
      curImg:{},
      equipmentObj:{}
    };  
  }, 
  mounted() {
    this.$nextTick(()=>{
      this.getInitEvent()
      this.cateEvent()
    })
  },
  methods:{
    
    cateEvent() {
      cate().then((res)=>{
          this.curImg = this.filterItemsByPath('/#/equipment',res.data).banner[0]
      })
    },
    filterItemsByPath(path,arr) {
      let _arr = []
      let newArr = []
      _arr = arr
      newArr =  _arr.filter(item => item.path === path);
      if (newArr.length > 0) {
        return newArr[0]; // 只取第一个匹配的对象
      } else {
        return {}; // 如果没有匹配的对象，返回空对象
      }
  },
    getInitEvent() {
      let _id = this.$route.query.id
      let _obj = {cateId:_id}
      getList(_obj).then((res)=>{
        this.equipmentObj = res.data
        this.equipmentObj.cateInfo.name = '生产管理'
      })
    },
    // handleDetail(item) {
    //    this.$router.push({path: '/solutionDetail',query:{id:item.id,model_type:item.model_type}})
    // }
  }
}
</script>
<style lang="scss" scoped>
.containerOne{
  .one{
    width:100%;
    margin:0 0 50px 0
  }
}
.footWords{
  padding:20px 0;
  line-height: 30px;
}
.clearBoth {
  clear:both
}
.tit {
  margin:0 0 20px 0;
  span{
    display: block;
    padding:5px 0 10px 0;
  }
}
</style>
